// Pure decision helpers for the sticker-sheet drag-to-dismiss gesture. The
// pointer wiring lives in the component; this is the testable core.

// Drag the sheet down this far (px) and release → dismiss.
export const SHEET_DRAG_DISMISS_DISTANCE = 120;
// …or flick it down at least this fast (px/ms) → dismiss even on a short drag.
export const SHEET_DRAG_DISMISS_VELOCITY = 0.6;
// Below this drag distance a fast flick is ignored — it's a tap/jitter, not a
// dismiss, so the sheet doesn't vanish from a stray touch.
export const SHEET_DRAG_MIN_FLICK_DISTANCE = 24;
// Movement past this (px, either axis) promotes a press on the handle into a
// drag (and captures the pointer); below it, a press stays a tap so child
// buttons still fire.
export const SHEET_DRAG_ARM_THRESHOLD = 6;

// The sheet can only be dragged DOWN from its open position — clamp upward drag
// (negative delta) to 0.
export function clampSheetDrag(deltaY: number): number {
    return deltaY > 0 ? deltaY : 0;
}

// Dismiss when dragged past the distance threshold, OR flicked down fast enough
// past the minimum flick distance.
export function shouldDismissSheet(
    deltaY: number,
    velocity: number,
    opts: { distance?: number; velocity?: number; minFlickDistance?: number } = {},
): boolean {
    const distance = opts.distance ?? SHEET_DRAG_DISMISS_DISTANCE;
    const minVel = opts.velocity ?? SHEET_DRAG_DISMISS_VELOCITY;
    const minFlick = opts.minFlickDistance ?? SHEET_DRAG_MIN_FLICK_DISTANCE;
    if (deltaY >= distance) return true;
    return deltaY >= minFlick && velocity >= minVel;
}
